//Componentes generales
import React, { useContext, useState } from "react";
import DropDownPicker from "../DropDownPicker/DropDownPicker";
import "bootstrap/dist/css/bootstrap.min.css";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

//Estilos
import "./GruposChange.css";

// Alertas
import Swal from "sweetalert2";
import { useEffect } from "react";

//Contexto
import gruposContext from "../../context/grupos/gruposContext";

function GruposChange({ item, codFor, nroFor, guardarGrupos, data, cerrar }) {
  const gContext = useContext(gruposContext);
  const { actualizarGroupList } = gContext;

  const [comprobante, setComprobante] = useState(item);
  const [gruposList, setGruposList] = useState([]);
  const [gruposComprobante, setGruposComprobante] = useState((data !== undefined) ? data : []);
  const [disabledButton, setDisabledButton] = useState(false);

  const enabled = {
    cursor: "pointer",
  };

  const disabled = {
    cursor: "not-allowed",
    display: "none",
  };

  useEffect(() => {
    const fn = async () => {
      const resp = await actualizarGroupList();
      const optionsGrupo =
        resp?.map((g) => ({ label: g.name, value: g._id })) || [];
      setGruposList(optionsGrupo);
    };
    fn();
  }, []);

  const save = async (tDoc) => {
    try {
      setDisabledButton(true);
      if (!gruposComprobante.length) {
        setDisabledButton(false);
        Swal.fire({
          icon: "warning",
          title: "Debe seleccionar al menos un grupo.",
        });
        return;
      }
      const gruposV = gruposComprobante.map((grupo) => {
        return grupo.value
      })
      tDoc.gruposV = gruposV;
      const resp = await guardarGrupos(tDoc, tDoc.gruposV);
      Swal.fire(
        "Grupos de usuarios del Comprobante:",
        "Los Grupos de usuarios que pueden visualizar el comprobante <strong>" + tDoc.tDocCodFor + " - " + tDoc.tDocNroFor + "</strong> fueron Modificados Correctamente <br> <strong>" +
        " </strong> ",
        "success"
      );
      setDisabledButton(false);
      cerrar(null);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al modificar los grupos",
        text: "Hubo un problema al intentar modificar los grupos. Intenta nuevamente más tarde.",
      });
      console.error("Error al guardar los grupos:", error);

      setDisabledButton(false);
      cerrar(null);
    }
  };

  return (
    <div className="container-gr-grupos">
      <div className="label-grupos-icon-r">
        <FontAwesomeIcon
          className="grupos-icon-r"
          icon={faXmark}
          onClick={() => cerrar(null)}
        />
      </div>
      <div className="container-grupos">
        <div className="label-grupos-data">
          <strong>{codFor + " - " + nroFor + " . Grupos: "}</strong>
        </div>
        <div className="dropdown-wrapper">
          <DropDownPicker
            options={gruposList}
            onChange={(value) => setGruposComprobante(value)}
            value={gruposComprobante}
            isComprobanteGroup={true}
          />
        </div>
        <div className="btn-grupos-container">
          <button
            className="btn-grupos"
            style={disabledButton ? disabled : enabled}
            disabled={disabledButton}
            onClick={() => save(comprobante)}
          >
            Cambiar Grupos
          </button>
        </div>
      </div>
    </div>
  );
}

export default GruposChange;